import styled from "styled-components";

export const Wrapper = styled.div`
  border-radius: var(--rounding-radius-xl, 24px);
  background: var(--background-elevated, #fff);
  box-shadow: 0px 4px 8px 0px rgba(20, 32, 102, 0.04),
    0px 8px 24px 0px rgba(20, 32, 102, 0.08);
  padding: 24px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  @media (min-width: 1024px) {
    padding: 24px 24px 20px;
  }
`;

export const MainPart = styled.div`
  display: flex;
  flex-direction: row-reverse;
  gap: 16px;
  margin-bottom: 20px;
  @media (min-width: 1024px) {
    flex-direction: row;
  }
`;

export const BonusSectionDesktop = styled.div`
  display: none;
  @media (min-width: 1024px) {
    display: flex;
    position: absolute;
    z-index: 1;
    margin-left: 4px;
  }
  img {
    margin-left: -4px;
  }
`;

export const BonusSectionMobile = styled.div`
  display: flex;
  margin-left: 4px;
  @media (min-width: 1024px) {
    display: none;
  }
  img {
    margin-left: -4px;
  }
`;

export const PictureContainer = styled.div`
  position: relative;
  isolation: isolate;
  display: flex;
  flex-direction: column;
`;

export const CoinImage = styled.div`
  width: 128px;
  height: 128px;
  @media (min-width: 1024px) {
    width: 160px;
    height: 160px;
  }
`;

export const PictureBar = styled.div`
  border-radius: var(--rounding-radius-m, 16px);
  background: var(--Points, #c8ff26);
  padding: var(--spacing-space-2, 2px) var(--spacing-space-6, 6px)
    var(--spacing-space-2, 2px) var(--spacing-space-2, 2px);
  align-items: center;
  display: flex;
  height: 24px;
  white-space: nowrap;
  flex-grow: 0;
  & > img {
    width: 22px;
    height: 22px;
  }
  color: #000;
  font-size: 12px;
  font-variation-settings: "wght" 500;
  letter-spacing: 0.5px;
  .haveBonus {
    display: none;
  }
  @media (min-width: 1024px) {
    height: 32px;
    font-size: 16px;
    .haveBonus {
      display: block;
    }
  }
`;

export const Bar = styled.div`
  left: 0;
  position: absolute;
  z-index: 4;
  gap: 4px;
  justify-content: center;
  width: 100%;
  display: flex;
  @media (min-width: 1024px) {
    top: auto;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const PoolInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: auto;
`;

export const Bonus = styled.div`
  position: absolute;
  top: 24px;
  right: 29px;
  z-index: 1;
  .bonus-blur {
    position: absolute;
    right: -580px;
    top: -530px;
    z-index: -1;
  }
  @media (min-width: 1024px) {
    top: 24px;
    left: 24px;
    right: 0;
    .bonus-blur {
      position: absolute;
      left: -500px;
      top: -500px;
      z-index: -1;
    }
  }
`;

export const Days = styled.div`
  height: 24px;
  display: flex;
  align-items: cemter;
  justify-content: center;
  width: fit-content;
  gap: 2px;
  border-radius: var(--rounding-radius-m, 16px);
  background: var(--fill-secondary, rgba(204, 187, 184, 0.16));
  backdrop-filter: blur(12px);
  margin: 8px 0;
  padding: 2px 8px 2px 0;
  white-space: nowrap;
  line-height: 1;
  p {
    font-size: 12px;
    font-variation-settings: "wght" 500;
    color: var(--text-primary);
  }
  img {
    flex-shrink: 0;
    filter: invert(var(--svg-invert));
  }
  @media (min-width: 1024px) {
    position: absolute;
    right: 24px;
    margin: 0;
  }
`;

export const Progress = styled.div`
  position: relative;
  border-radius: var(--rounding-radius-xxs, 4px);
  background: var(--fill-secondary, rgba(204, 187, 184, 0.16));
  height: 8px;
  .painted {
    border-radius: var(--rounding-radius-xxs, 4px);
    background: var(--fill-accent-primary, #9fe);
    position: absolute;
    left: 0;
    top: 0;
    width: 30%;
    height: 100%;
  }
`;
